/**
 * This is a compiled JS file.
 * Changes here could be overwritten. 
 * Contact your Shopify developers if changes need to be made.
 */

const updateNibbleButtonProduct = (showBar) => {
  let nibbleButton = document.querySelector("#fc_frame")
          
  if(nibbleButton){
    if(showBar){
      nibbleButton.classList.add("fc_frame-offset")
    }else{
      nibbleButton.classList.remove("fc_frame-offset")
    }
  }else{
    setTimeout(updateNibbleButtonProduct(), 3000)
  }
}

// Check for nibble for certain amount of time to offset it when it loads in
let elapsedCheckForNibbleProduct = 0
let elapsedCheckForNibbleMaxProduct = 10 * 1000
let elapsedCheckForNibbleDelayProduct = 500

const checkForNibbleProduct = () => {
  if(elapsedCheckForNibbleProduct >= elapsedCheckForNibbleMaxProduct) return;

  let nibbleButton = document.querySelector("#fc_frame")

  if (nibbleButton) {
    nibbleButton.classList.add("fc_frame-offset")
    
    return;
  }
  
  setTimeout( checkForNibbleProduct, elapsedCheckForNibbleDelayProduct );
  elapsedCheckForNibbleProduct += elapsedCheckForNibbleDelayProduct;
}

window.when('.js-product-atc-bar', () => {
    checkForNibbleProduct()

    const el = document.querySelector('.js-product-atc-bar');
    const trigger = document.querySelector('.js-product-atc-bar-trigger');
    if(!el) return;
    const btn = el.querySelector('.js-btn');
    const target = document.querySelector('.js-product-atc-bar-target');
  
    btn.addEventListener('click', (e) => {
      target.scrollIntoView({behavior: 'smooth', block: 'center'});
      e.preventDefault();
    });
  
    if (
      'IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window &&
      'intersectionRatio' in window.IntersectionObserverEntry.prototype
    ) {
      const observer = new IntersectionObserver((entries) => {
        let rect = entries[0].boundingClientRect
        let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        // const showBar = (entries[0].boundingClientRect.y < 0);
        let showBar = (rect.bottom < 0 || rect.top - viewHeight >= 0);

        console.log(`dupi - shwoing = ${showBar}`)
        console.log(`dupi - entries[0] = ${entries[0].boundingClientRect.y}`)
        console.log(`dupi - showbar = ${showBar}`)

        el.classList.toggle('is-visible', showBar);

        updateNibbleButtonProduct(showBar);
      }, {
        threshold: 1.0,
        root: null,
      });
  
      observer.observe(trigger);
    }
  });